module.exports = __webpack_public_path__ + "static/mongo-3094ead7d89614d2a8557c31bab0077b.svg";